import { CommitmentSourcesService } from '@festina/life-general-types/life/services/CommitmentSourcesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  CommitmentSourcesService.commitmentSourcesExternalPayloadsServicePostSkipAutoHandling

type Props = {
  ownerId: string
  tenantId: string
}

export const useSkipAutoHandlingCommitmentSourceExternalPayload = ({
  ownerId,
  tenantId,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    isScenario: false,
    mutateFunction: async ({
      postingId,
    }: Pick<Parameters<typeof method>[0], 'postingId'>) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        postingId,
      })
    },
    roles:
      CommitmentSourcesService.commitmentSourcesExternalPayloadsServicePostSkipAutoHandling_roles,
  })
